import { JsonRpcSigner, Signer } from 'ethers';

import config from 'config';
import { getCurrentStateChainConfig } from 'config/configUtils';
import {
  KatanaExchange_v1__factory,
  FixedIncomeVaultProvider_v1__factory,
  // FixedIncomeVaultProvider_v1,
  // FixedIncomeVaultProviderStateAggregator_v1,
  FixedIncomeVaultProviderStateAggregator_v1__factory,
} from 'lib/ethereum/contracts/contractsFromSdk';
import { getSigner } from 'lib/ethereum/wallets';
import { triggerWalletChainSwitchIfPossible } from 'lib/ethereum/wallets/switchEthereumChain';
import { getAnonymousRPCProvider } from 'lib/ethereum/wallets/utils';
import { IWallet } from 'reduxState/wallet/walletReducer';

/** https://github.com/berachain/contracts/blob/main/src/pol/rewards/RewardVault.sol#L318 */
export function getVaultProviderContract(signer?: Signer | JsonRpcSigner) {
  return FixedIncomeVaultProvider_v1__factory.connect(
    config.chains.katanaChain.fixedIncomeVaultProviderAddress,
    signer ?? getAnonymousRPCProvider()
  );
}

export function getVaultAggregatorContract() {
  return FixedIncomeVaultProviderStateAggregator_v1__factory.connect(
    config.chains.katanaChain.fixedIncomeVaultProviderStateAggregatorAddress,
    getAnonymousRPCProvider()
  );
}

export function getExchangeContract() {
  return KatanaExchange_v1__factory.connect(
    config.chains.katanaChain.exchangeContract,
    getAnonymousRPCProvider()
  );
}

// TODO: vaults use when available as export from SDK LoadVaultDepositorsResultStructOutput;
export type LoadVaultDepositorsResultStructOutput = {
  costBasis: bigint;
  initialDepositTimestampInS: bigint;
  owedQuantity: bigint;
};

export const getKatanaWalletSigner = async (wallet: IWallet) => {
  const chainConfig = getCurrentStateChainConfig('katanaChain');
  await triggerWalletChainSwitchIfPossible(
    wallet.walletType,
    chainConfig,
    await getSigner(wallet, undefined, false)
  );
  return await getSigner(wallet);
};
